var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.size == 'PC')?_c('topNav'):_vm._e(),(_vm.size == 'PHONE')?_c('topNavPhone'):_vm._e(),_c('div',[_c('router-view')],1),(_vm.size == 'PC')?_c('appFooter'):_vm._e(),(_vm.size == 'PHONE')?_c('appFooterPhone'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }